import React from "react";

type ListingCoachNameWrapperProps = React.ComponentProps<"div">;

export const ListingCoachNameWrapper = ({
  className,
  children,
  ...props
}: ListingCoachNameWrapperProps) => {
  return (
    <div className="flex items-center  space-x-[12px]" {...props}>
      {children}
    </div>
  );
};
